import { useAuth } from '../contexts/AuthContext';
import { useRef, useEffect } from 'react';
import { renderGoogleButton } from '../services/googleOneTap';
import { Button } from '@hyggecards/design-system';
import './AuthButton.css';

export function AuthButton() {
  const { user, isLoading, isAuthenticated, signOut, authEnabled } = useAuth();
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Render Google button when not authenticated
    if (!isLoading && !isAuthenticated && authEnabled && buttonRef.current) {
      renderGoogleButton(buttonRef.current);
    }
  }, [isLoading, isAuthenticated, authEnabled]);

  // Auth not configured - don't show anything
  if (!authEnabled) {
    return null;
  }

  // Loading state
  if (isLoading) {
    return <div className="auth-button auth-loading">...</div>;
  }

  // Authenticated - show sign out button only
  if (isAuthenticated && user) {
    return (
      <div className="auth-button">
        <Button variant="secondary" onClick={signOut}>
          Sign out
        </Button>
      </div>
    );
  }

  // Not authenticated - show Google sign-in button
  return (
    <div className="auth-button">
      <div ref={buttonRef} className="google-signin-container" />
    </div>
  );
}
